module.exports = __webpack_public_path__ + "img/tireExampleAlt.39b7c9e0.svg";